import React, { useEffect, useState } from 'react';
import ValConfig from './ValConfig';
import axios from 'axios';
import { API_URL } from '../../Constants';

function Configs(props) {
    let [confs, setConfs] = useState([])
    useEffect(() => {
        axios.get(`${API_URL}/configs`)
            .then(res => {
                setConfs(res.data)
            })
            .catch(err => {
            })
    }, []);

    

    return (
        <div>
            <ValConfig initialValues={(confs.length > 0) ? confs.find(c => c.kalit === 'kurs') : {}}/>
        </div>
    );
}

export default Configs;